import React from 'react';
import Reveal, { RevealGroup } from './ui/Reveal';
import SectionLabel from './ui/SectionLabel';
import { sustaining } from '../data/content';

/** "Building a Self-Sustaining Ministry" — stewardship, the Marketplace, and
 *  the brief's three-step statement of intent. */
export default function SelfSustaining() {
  return (
    <section id="sustaining" className="bg-cream py-24 sm:py-32">
      <div className="shell">
        <div className="grid gap-14 lg:grid-cols-2 lg:gap-20">
          <div>
            <Reveal variant="fade">
              <SectionLabel index="05">Stewardship</SectionLabel>
            </Reveal>

            <Reveal
              as="h2"
              delay={80}
              className="mt-7 font-display text-[2rem] font-semibold uppercase leading-[1.06] tracking-[0.01em] text-ink sm:text-4xl lg:text-[3rem]"
            >
              {sustaining.title}
            </Reveal>
            <Reveal variant="rule" delay={240} className="rule mt-6" />

            <Reveal
              as="p"
              delay={300}
              className="mt-8 font-display text-xl uppercase tracking-[0.06em] text-gold-700 sm:text-2xl"
            >
              {sustaining.lead}
            </Reveal>
            {sustaining.body.map((line, i) => (
              <Reveal
                as="p"
                key={line}
                delay={360 + i * 80}
                className="mt-5 text-[0.98rem] leading-relaxed text-ink/75"
              >
                {line}
              </Reveal>
            ))}
          </div>

          <div className="flex flex-col gap-7">
            <Reveal
              variant="right"
              delay={140}
              className="border-l-2 border-gold bg-white/70 p-8 shadow-card transition-shadow duration-500 hover:shadow-card-hover"
            >
              <h3 className="font-display text-lg font-semibold uppercase tracking-[0.16em] text-ink">
                {sustaining.marketplace.title}
              </h3>
              <p className="mt-4 text-[0.98rem] leading-relaxed text-ink/75">{sustaining.marketplace.body}</p>
            </Reveal>
            <Reveal as="p" variant="right" delay={240} className="text-[0.98rem] leading-relaxed text-ink/75">
              {sustaining.growth}
            </Reveal>
          </div>
        </div>

        <div className="mt-20">
          <Reveal as="p" variant="fade" className="text-center text-[0.7rem] uppercase tracking-[0.3em] text-ink/60">
            {sustaining.desire}
          </Reveal>

          <RevealGroup as="ol" variant="up" stagger={140} delay={120} className="mt-10 grid gap-10 sm:grid-cols-3">
            {sustaining.steps.map((step) => (
              <li key={step.n} className="group relative pt-6">
                {/* The rule above each step draws itself as the step arrives. */}
                <span className="absolute inset-x-0 top-0 h-px bg-ink/12" aria-hidden="true">
                  <span className="block h-full w-full origin-left scale-x-0 bg-gold transition-transform duration-700 ease-out-expo group-hover:scale-x-100" />
                </span>
                <span className="font-display text-sm font-semibold tracking-[0.24em] text-gold">{step.n}</span>
                <p className="mt-3 font-display text-lg uppercase leading-snug tracking-[0.06em] text-ink sm:text-xl">
                  {step.text}
                </p>
              </li>
            ))}
          </RevealGroup>
        </div>
      </div>
    </section>
  );
}
